<template>
  <div class="about-container">
    <!-- 使用公共导航栏组件 -->
    <Nav />

    <!-- 主要内容区域 -->
    <main class="mt-20 min-h-screen">
      <!-- Hero 区域 -->
      <section
        class="relative bg-gradient-to-br from-blue-50 to-white py-20 overflow-hidden"
        style="
          background-image: url('https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20building%20with%20professional%20team%20working%20together%2C%20business%20meeting%20atmosphere%2C%20clean%20white%20background%20on%20left%20side%2C%20professional%20equipment%20setup%2C%20corporate%20environment&width=1400&height=600&seq=about-hero&orientation=landscape');
          background-size: cover;
          background-position: center;
        "
      >
        <div
          class="absolute inset-0 bg-gradient-to-r from-white via-white/95 to-transparent"
        ></div>
        <div class="relative max-w-7xl mx-auto px-6">
          <div class="w-full flex items-center min-h-[400px]">
            <div class="w-1/2">
              <h1 class="text-5xl font-bold text-gray-900 mb-6">关于我们</h1>
              <p class="text-xl text-gray-600 mb-8 leading-relaxed">
                专业的会展设备租赁服务商，致力于为每一场展会提供完美的技术解决方案。我们以专业的团队、先进的设备和贴心的服务，成就您的每一次精彩展示。
              </p>
              <div class="flex items-center space-x-6">
                <div class="text-center">
                  <div class="text-3xl font-bold text-primary">8+</div>
                  <div class="text-sm text-gray-500">年行业经验</div>
                </div>
                <div class="text-center">
                  <div class="text-3xl font-bold text-primary">500+</div>
                  <div class="text-sm text-gray-500">成功案例</div>
                </div>
                <div class="text-center">
                  <div class="text-3xl font-bold text-primary">98%</div>
                  <div class="text-sm text-gray-500">客户满意度</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 公司简介 -->
      <section class="py-16 bg-white">
        <div class="max-w-7xl mx-auto px-6">
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20exhibition%20equipment%20warehouse%20with%20organized%20storage%2C%20modern%20LED%20displays%2C%20audio%20systems%2C%20staging%20materials%2C%20clean%20industrial%20environment%2C%20professional%20lighting&width=600&height=400&seq=company-intro&orientation=landscape"
                alt="公司设备展示"
                class="w-full h-96 object-cover rounded-xl shadow-lg"
              />
            </div>
            <div>
              <h2 class="text-3xl font-bold text-gray-900 mb-6">
                专业设备 · 品质服务
              </h2>
              <p class="text-gray-600 mb-6 leading-relaxed">
                成立于 2016
                年，我们是一家专注于会展设备租赁的专业服务商。公司拥有完善的设备库存体系，涵盖视听设备、会展家具、搭建材料、互动设备等多个品类，能够满足各类展会、会议、活动的需求。
              </p>
              <p class="text-gray-600 mb-6 leading-relaxed">
                我们秉承"专业、高效、创新"的服务理念，为客户提供从方案设计、设备租赁、现场搭建到技术支持的一站式服务。凭借丰富的行业经验和专业的技术团队，已成功服务超过
                500 家企业客户。
              </p>
              <div class="grid grid-cols-2 gap-4 mb-8">
                <div class="flex items-center space-x-3">
                  <div
                    class="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center"
                  >
                    <i class="ri-award-line text-primary"></i>
                  </div>
                  <span class="text-gray-700">ISO 9001 质量认证</span>
                </div>
                <div class="flex items-center space-x-3">
                  <div
                    class="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center"
                  >
                    <i class="ri-shield-check-line text-primary"></i>
                  </div>
                  <span class="text-gray-700">全程保险保障</span>
                </div>
                <div class="flex items-center space-x-3">
                  <div
                    class="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center"
                  >
                    <i class="ri-time-line text-primary"></i>
                  </div>
                  <span class="text-gray-700">24 小时技术支持</span>
                </div>
                <div class="flex items-center space-x-3">
                  <div
                    class="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center"
                  >
                    <i class="ri-truck-line text-primary"></i>
                  </div>
                  <span class="text-gray-700">全国配送服务</span>
                </div>
              </div>
              <a
                href="https://readdy.ai/home/434f6558-6cf9-49c0-a4fe-e7e81eb49386/e0472ad5-5c53-44f1-bf76-a06b0c25d248"
                data-readdy="true"
                class="inline-flex items-center bg-primary text-white px-6 py-3 !rounded-button hover:bg-secondary transition-colors whitespace-nowrap"
              >
                了解更多服务
                <i class="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      <!-- 发展历程 -->
      <section class="py-16 bg-gray-50">
        <div class="max-w-7xl mx-auto px-6">
          <div class="text-center mb-12">
            <h2 class="text-3xl font-bold text-gray-900 mb-4">发展历程</h2>
            <p class="text-gray-600">见证我们的成长足迹，共创美好未来</p>
          </div>
          <div class="relative">
            <div
              class="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-gradient-to-b from-primary to-secondary"
            ></div>
            <div class="space-y-12">
              <!-- 2016 年 -->
              <div class="flex items-center">
                <div class="w-1/2 pr-8 text-right">
                  <div class="bg-white rounded-xl p-6 shadow-sm">
                    <h3 class="text-xl font-semibold text-gray-900 mb-2">
                      公司成立
                    </h3>
                    <p class="text-gray-600 text-sm">
                      在北京正式成立，专注会展设备租赁服务，初期团队 8
                      人，设备库存价值 200 万元。
                    </p>
                  </div>
                </div>
                <div class="relative flex items-center justify-center">
                  <div
                    class="w-12 h-12 bg-primary rounded-full flex items-center justify-center text-white font-bold z-10"
                  >
                    2016
                  </div>
                </div>
                <div class="w-1/2 pl-8"></div>
              </div>
              <!-- 2018 年 -->
              <div class="flex items-center">
                <div class="w-1/2 pr-8"></div>
                <div class="relative flex items-center justify-center">
                  <div
                    class="w-12 h-12 bg-primary rounded-full flex items-center justify-center text-white font-bold z-10"
                  >
                    2018
                  </div>
                </div>
                <div class="w-1/2 pl-8">
                  <div class="bg-white rounded-xl p-6 shadow-sm">
                    <h3 class="text-xl font-semibold text-gray-900 mb-2">
                      业务拓展
                    </h3>
                    <p class="text-gray-600 text-sm">
                      服务范围扩展至华东地区，在上海设立分公司，团队规模扩大至
                      25 人，年服务客户超过 100 家。
                    </p>
                  </div>
                </div>
              </div>
              <!-- 2020 年 -->
              <div class="flex items-center">
                <div class="w-1/2 pr-8 text-right">
                  <div class="bg-white rounded-xl p-6 shadow-sm">
                    <h3 class="text-xl font-semibold text-gray-900 mb-2">
                      技术升级
                    </h3>
                    <p class="text-gray-600 text-sm">
                      引入 AR/VR
                      互动设备，推出智能化展台解决方案，获得"年度创新服务商"荣誉称号。
                    </p>
                  </div>
                </div>
                <div class="relative flex items-center justify-center">
                  <div
                    class="w-12 h-12 bg-primary rounded-full flex items-center justify-center text-white font-bold z-10"
                  >
                    2020
                  </div>
                </div>
                <div class="w-1/2 pl-8"></div>
              </div>
              <!-- 2022 年 -->
              <div class="flex items-center">
                <div class="w-1/2 pr-8"></div>
                <div class="relative flex items-center justify-center">
                  <div
                    class="w-12 h-12 bg-primary rounded-full flex items-center justify-center text-white font-bold z-10"
                  >
                    2022
                  </div>
                </div>
                <div class="w-1/2 pl-8">
                  <div class="bg-white rounded-xl p-6 shadow-sm">
                    <h3 class="text-xl font-semibold text-gray-900 mb-2">
                      全国布局
                    </h3>
                    <p class="text-gray-600 text-sm">
                      在广州、深圳、成都设立服务中心，实现全国主要城市覆盖，累计服务客户突破
                      400 家。
                    </p>
                  </div>
                </div>
              </div>
              <!-- 2024 年 -->
              <div class="flex items-center">
                <div class="w-1/2 pr-8 text-right">
                  <div
                    class="bg-white rounded-xl p-6 shadow-sm border-2 border-primary"
                  >
                    <h3 class="text-xl font-semibold text-gray-900 mb-2">
                      数字化转型
                    </h3>
                    <p class="text-gray-600 text-sm">
                      推出在线租赁平台，实现设备预订、项目管理、服务跟踪全流程数字化，开启智慧会展新时代。
                    </p>
                  </div>
                </div>
                <div class="relative flex items-center justify-center">
                  <div
                    class="w-12 h-12 bg-gradient-to-r from-primary to-secondary rounded-full flex items-center justify-center text-white font-bold z-10"
                  >
                    2024
                  </div>
                </div>
                <div class="w-1/2 pl-8"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 团队介绍 -->
      <section class="py-16 bg-white">
        <div class="max-w-7xl mx-auto px-6">
          <div class="text-center mb-12">
            <h2 class="text-3xl font-bold text-gray-900 mb-4">核心团队</h2>
            <p class="text-gray-600">专业的团队是我们服务品质的保障</p>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <!-- 团队成员 1 -->
            <div
              class="bg-white rounded-xl shadow-sm border border-gray-100 p-6 text-center hover:shadow-lg transition-shadow"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20executive%20portrait%2C%20confident%20smile%2C%20corporate%20headshot%2C%20clean%20background%2C%20middle-aged%20man%20in%20suit&width=200&height=200&seq=team1&orientation=squarish"
                alt="陈建华"
                class="w-20 h-20 rounded-full mx-auto mb-4 object-cover"
              />
              <h3 class="text-lg font-semibold text-gray-900 mb-1">陈建华</h3>
              <p class="text-primary text-sm mb-3">创始人 & CEO</p>
              <p class="text-gray-600 text-xs leading-relaxed">
                15
                年会展行业经验，曾任职于国际知名展览公司，深耕会展设备租赁领域，致力于为客户提供专业服务。
              </p>
            </div>
            <!-- 团队成员 2 -->
            <div
              class="bg-white rounded-xl shadow-sm border border-gray-100 p-6 text-center hover:shadow-lg transition-shadow"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20Chinese%20businesswoman%20portrait%2C%20confident%20smile%2C%20corporate%20headshot%2C%20clean%20background%2C%20middle-aged%20woman%20in%20business%20attire&width=200&height=200&seq=team2&orientation=squarish"
                alt="李雪梅"
                class="w-20 h-20 rounded-full mx-auto mb-4 object-cover"
              />
              <h3 class="text-lg font-semibold text-gray-900 mb-1">李雪梅</h3>
              <p class="text-primary text-sm mb-3">技术总监</p>
              <p class="text-gray-600 text-xs leading-relaxed">
                音响工程师出身，拥有丰富的大型活动技术支持经验，负责公司技术团队管理和设备质量把控。
              </p>
            </div>
            <!-- 团队成员 3 -->
            <div
              class="bg-white rounded-xl shadow-sm border border-gray-100 p-6 text-center hover:shadow-lg transition-shadow"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20Chinese%20young%20businessman%20portrait%2C%20confident%20smile%2C%20corporate%20headshot%2C%20clean%20background%2C%20young%20man%20in%20business%20casual&width=200&height=200&seq=team3&orientation=squarish"
                alt="王志强"
                class="w-20 h-20 rounded-full mx-auto mb-4 object-cover"
              />
              <h3 class="text-lg font-semibold text-gray-900 mb-1">王志强</h3>
              <p class="text-primary text-sm mb-3">运营总监</p>
              <p class="text-gray-600 text-xs leading-relaxed">
                物流管理专业背景，擅长供应链优化和项目管理，确保设备及时配送和现场执行的高效运转。
              </p>
            </div>
            <!-- 团队成员 4 -->
            <div
              class="bg-white rounded-xl shadow-sm border border-gray-100 p-6 text-center hover:shadow-lg transition-shadow"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20Chinese%20young%20businesswoman%20portrait%2C%20confident%20smile%2C%20corporate%20headshot%2C%20clean%20background%2C%20young%20woman%20in%20professional%20attire&width=200&height=200&seq=team4&orientation=squarish"
                alt="张晓琳"
                class="w-20 h-20 rounded-full mx-auto mb-4 object-cover"
              />
              <h3 class="text-lg font-semibold text-gray-900 mb-1">张晓琳</h3>
              <p class="text-primary text-sm mb-3">客户总监</p>
              <p class="text-gray-600 text-xs leading-relaxed">
                市场营销专业，具备敏锐的市场洞察力和优秀的客户服务能力，负责客户关系维护和业务拓展。
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- 企业文化 -->
      <section class="py-16 bg-gray-50">
        <div class="max-w-7xl mx-auto px-6">
          <div class="text-center mb-12">
            <h2 class="text-3xl font-bold text-gray-900 mb-4">企业文化</h2>
            <p class="text-gray-600">我们的价值观指引着每一次服务</p>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <!-- 企业愿景 -->
            <div
              class="bg-white rounded-xl p-8 text-center shadow-sm hover:shadow-lg transition-shadow"
            >
              <div
                class="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6"
              >
                <i class="ri-eye-line text-2xl text-primary"></i>
              </div>
              <h3 class="text-xl font-semibold text-gray-900 mb-4">企业愿景</h3>
              <p class="text-gray-600 leading-relaxed">
                成为中国领先的会展设备租赁服务商，为每一场展会创造完美体验。
              </p>
            </div>
            <!-- 企业使命 -->
            <div
              class="bg-white rounded-xl p-8 text-center shadow-sm hover:shadow-lg transition-shadow"
            >
              <div
                class="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6"
              >
                <i class="ri-rocket-line text-2xl text-primary"></i>
              </div>
              <h3 class="text-xl font-semibold text-gray-900 mb-4">企业使命</h3>
              <p class="text-gray-600 leading-relaxed">
                通过专业的设备和优质的服务，助力客户展示品牌价值，实现商业成功。
              </p>
            </div>
            <!-- 核心价值观 -->
            <div
              class="bg-white rounded-xl p-8 text-center shadow-sm hover:shadow-lg transition-shadow"
            >
              <div
                class="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6"
              >
                <i class="ri-heart-line text-2xl text-primary"></i>
              </div>
              <h3 class="text-xl font-semibold text-gray-900 mb-4">
                核心价值观
              </h3>
              <p class="text-gray-600 leading-relaxed">
                专业、诚信、创新、共赢，以客户需求为导向，持续提升服务品质。
              </p>
            </div>
            <!-- 文化理念 -->
            <div
              class="bg-white rounded-xl p-8 text-center shadow-sm hover:shadow-lg transition-shadow"
            >
              <div
                class="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6"
              >
                <i class="ri-lightbulb-line text-2xl text-primary"></i>
              </div>
              <h3 class="text-xl font-semibold text-gray-900 mb-4">文化理念</h3>
              <p class="text-gray-600 leading-relaxed">
                追求卓越，永不止步。我们相信每一个细节都能成就完美的展示效果。
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- 资质荣誉 -->
      <section class="py-16 bg-white">
        <div class="max-w-7xl mx-auto px-6">
          <div class="text-center mb-12">
            <h2 class="text-3xl font-bold text-gray-900 mb-4">资质荣誉</h2>
            <p class="text-gray-600">专业资质认证，行业权威认可</p>
          </div>
          <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            <!-- 资质证书 1 -->
            <div
              class="bg-gray-50 rounded-xl p-6 text-center hover:shadow-lg transition-shadow cursor-pointer certificate-item"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20business%20certificate%20document%2C%20ISO%209001%20quality%20management%20certification%2C%20official%20seal%20and%20signatures%2C%20clean%20white%20background&width=200&height=280&seq=cert1&orientation=portrait"
                alt="ISO 9001 认证"
                class="w-full h-32 object-cover rounded-lg mb-4"
              />
              <h4 class="text-sm font-medium text-gray-900">ISO 9001 认证</h4>
              <p class="text-xs text-gray-500 mt-1">质量管理体系</p>
            </div>
            <!-- 资质证书 2 -->
            <div
              class="bg-gray-50 rounded-xl p-6 text-center hover:shadow-lg transition-shadow cursor-pointer certificate-item"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Business%20license%20certificate%20document%2C%20official%20government%20approval%2C%20red%20seal%20and%20signatures%2C%20professional%20layout&width=200&height=280&seq=cert2&orientation=portrait"
                alt="营业执照"
                class="w-full h-32 object-cover rounded-lg mb-4"
              />
              <h4 class="text-sm font-medium text-gray-900">营业执照</h4>
              <p class="text-xs text-gray-500 mt-1">工商注册证明</p>
            </div>
            <!-- 资质证书 3 -->
            <div
              class="bg-gray-50 rounded-xl p-6 text-center hover:shadow-lg transition-shadow cursor-pointer certificate-item"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Industry%20award%20certificate%2C%20excellence%20in%20service%20recognition%2C%20golden%20seal%20and%20ribbon%2C%20prestigious%20design&width=200&height=280&seq=cert3&orientation=portrait"
                alt="优秀服务商"
                class="w-full h-32 object-cover rounded-lg mb-4"
              />
              <h4 class="text-sm font-medium text-gray-900">优秀服务商</h4>
              <p class="text-xs text-gray-500 mt-1">行业协会认证</p>
            </div>
            <!-- 资质证书 4 -->
            <div
              class="bg-gray-50 rounded-xl p-6 text-center hover:shadow-lg transition-shadow cursor-pointer certificate-item"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Safety%20certification%20document%2C%20equipment%20safety%20standards%20compliance%2C%20official%20approval%20stamp%2C%20technical%20certification&width=200&height=280&seq=cert4&orientation=portrait"
                alt="安全认证"
                class="w-full h-32 object-cover rounded-lg mb-4"
              />
              <h4 class="text-sm font-medium text-gray-900">安全认证</h4>
              <p class="text-xs text-gray-500 mt-1">设备安全标准</p>
            </div>
            <!-- 资质证书 5 -->
            <div
              class="bg-gray-50 rounded-xl p-6 text-center hover:shadow-lg transition-shadow cursor-pointer certificate-item"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Innovation%20award%20certificate%2C%20technology%20innovation%20recognition%2C%20modern%20design%20with%20blue%20accents%2C%20prestigious%20award&width=200&height=280&seq=cert5&orientation=portrait"
                alt="创新奖项"
                class="w-full h-32 object-cover rounded-lg mb-4"
              />
              <h4 class="text-sm font-medium text-gray-900">创新奖项</h4>
              <p class="text-xs text-gray-500 mt-1">技术创新认可</p>
            </div>
            <!-- 资质证书 6 -->
            <div
              class="bg-gray-50 rounded-xl p-6 text-center hover:shadow-lg transition-shadow cursor-pointer certificate-item"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Customer%20satisfaction%20award%2C%20service%20excellence%20certificate%2C%20customer%20choice%20recognition%2C%20professional%20certificate%20design&width=200&height=280&seq=cert6&orientation=portrait"
                alt="客户满意度"
                class="w-full h-32 object-cover rounded-lg mb-4"
              />
              <h4 class="text-sm font-medium text-gray-900">客户满意度</h4>
              <p class="text-xs text-gray-500 mt-1">服务质量认证</p>
            </div>
          </div>
        </div>
      </section>

      <!-- 联系方式 -->
      <section class="py-16 bg-gray-50">
        <div class="max-w-7xl mx-auto px-6">
          <div class="text-center mb-12">
            <h2 class="text-3xl font-bold text-gray-900 mb-4">联系我们</h2>
            <p class="text-gray-600">随时为您提供专业的会展设备租赁服务</p>
          </div>
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <!-- 联系信息 -->
            <div class="bg-white rounded-xl p-8 shadow-sm w-full">
                <h3 class="text-xl font-semibold text-gray-900 mb-6">
                  联系信息
                </h3>
                <div class="space-y-6">
                  <div class="flex items-start space-x-4">
                    <div
                      class="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0"
                    >
                      <i class="ri-phone-line text-primary text-lg"></i>
                    </div>
                    <div>
                      <h4 class="font-medium text-gray-900 mb-1">客服热线</h4>
                      <p class="text-gray-600">010-84855667</p>
                      <p class="text-sm text-gray-500">周一至周日 8:00-22:00</p>
                    </div>
                  </div>
                  <div class="flex items-start space-x-4">
                    <div
                      class="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0"
                    >
                      <i class="ri-mail-line text-primary text-lg"></i>
                    </div>
                    <div>
                      <h4 class="font-medium text-gray-900 mb-1">邮箱地址</h4>
                      <p class="text-gray-600">service@redfocus.cn</p>
                      <p class="text-sm text-gray-500">24 小时内回复</p>
                    </div>
                  </div>
                  <div class="flex items-start space-x-4">
                    <div
                      class="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0"
                    >
                      <i class="ri-map-pin-line text-primary text-lg"></i>
                    </div>
                    <div>
                      <h4 class="font-medium text-gray-900 mb-1">公司地址</h4>
                      <p class="text-gray-600">
                        北京市西城区北三环中路29号华龙大厦B座24层
                      </p>
                      <p class="text-sm text-gray-500">
                        欢迎来访洽谈合作！
                      </p>
                    </div>
                  </div>
                  <div class="flex items-start space-x-4">
                    <div
                      class="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0"
                    >
                      <i class="ri-time-line text-primary text-lg"></i>
                    </div>
                    <div>
                      <h4 class="font-medium text-gray-900 mb-1">营业时间</h4>
                      <p class="text-gray-600">周一至周五 9:00-18:00</p>
                      <p class="text-sm text-gray-500">周末及节假日预约服务</p>
                    </div>
                  </div>
                </div>
            </div>

            <!-- 在线留言 -->
            <div class="bg-white rounded-xl p-8 shadow-sm w-full mt-8 lg:mt-0">
                <h3 class="text-xl font-semibold text-gray-900 mb-6">
                  在线留言
                </h3>
                <form class="space-y-4" id="contact-form">
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <input
                        type="text"
                        placeholder="您的姓名"
                        class="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                        required
                      />
                    </div>
                    <div>
                      <input
                        type="tel"
                        placeholder="联系电话"
                        class="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                        required
                      />
                    </div>
                  </div>
                  <div>
                    <input
                      type="email"
                      placeholder="邮箱地址"
                      class="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                      required
                    />
                  </div>
                  <div>
                    <select
                      class="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm pr-8"
                      required
                    >
                      <option value="">请选择咨询类型</option>
                      <option value="equipment">设备租赁咨询</option>
                      <option value="service">服务方案咨询</option>
                      <option value="cooperation">合作洽谈</option>
                      <option value="complaint">投诉建议</option>
                      <option value="other">其他</option>
                    </select>
                  </div>
                  <div>
                    <textarea
                      placeholder="请详细描述您的需求..."
                      class="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm h-32 resize-none"
                      required
                    ></textarea>
                  </div>
                  <button
                    type="submit"
                    class="w-full bg-primary text-white py-3 px-6 !rounded-button hover:bg-secondary transition-colors whitespace-nowrap"
                  >
                    提交留言
                  </button>
                </form>
            </div>

          </div>
        </div>
      </section>
    </main>

    <!-- 证书查看模态框 -->
    <div
      id="certificate-modal"
      class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 hidden"
    >
      <div class="bg-white rounded-xl max-w-2xl w-full mx-4 overflow-hidden">
        <div
          class="flex items-center justify-between p-6 border-b border-gray-200"
        >
          <h3 class="text-xl font-semibold text-gray-900">资质证书</h3>
          <button
            id="close-certificate-modal"
            class="w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors"
          >
            <i class="ri-close-line text-gray-500"></i>
          </button>
        </div>
        <div id="certificate-content" class="p-6">
          <!-- 证书内容将通过 JavaScript 动态填充 -->
        </div>
      </div>
    </div>

    <!-- 使用公共页脚组件 -->
    <Footer />
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "About",
  components: {
    Nav,
    Footer,
  },
};
</script>

<style scoped>
/* 容器样式 */
.about-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

</style>



// WEBPACK FOOTER //
// src/pages/mainpage/About.vue